import { createAdaptivePoller } from "@/utils/adaptive-polling";
import { useEffect, useRef } from "react";

type UseAdaptivePollingOptions = {
    intervalMs: number;
    maxBackoffMs?: number;
    enabled?: boolean;
    refreshKey?: unknown;
};

export function useAdaptivePolling(task: (controller: AbortController) => Promise<void>, options: UseAdaptivePollingOptions) {
    const taskRef = useRef(task);
    taskRef.current = task;

    useEffect(() => {
        if (options.enabled === false) return;

        const poller = createAdaptivePoller(controller => taskRef.current(controller), {
            intervalMs: options.intervalMs,
            maxBackoffMs: options.maxBackoffMs,
            isActive: () => document.visibilityState === "visible"
        });
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                poller.trigger();
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        poller.start();

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            poller.stop();
        };
    }, [options.enabled, options.intervalMs, options.maxBackoffMs, options.refreshKey]);
}
